import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Button, Form as BForm, Spinner } from '@themesberg/react-bootstrap'
import './reorderUIComponents.scss'
import useCheckPermission from '../../utils/checkPermission'
import { Card } from 'react-bootstrap'
import { routeToModuleKey } from '../../constants/permission'

const ReorderUIComponents = ({
  onDragEnd, loading, updateComponents, handleVisibilityToggle, data, droppableId
}) => {
  const { isHidden } = useCheckPermission()

  // Determines if the module should be hidden based on the droppableId.
  // If the droppableId is 'home-page', it checks the visibility for 'UIManagement'.
  // Otherwise, it checks the visibility for 'AccountManagement'.
  const moduleKey = routeToModuleKey[droppableId]

  // Check if the update action should be disabled based on the module's permission.
  const isUpdateDisabled = isHidden({ module: { key: moduleKey, value: 'U' } })

  const checkIsToggleHidden = (componentName) => {
    /*
      Deposit and withdraw tabs are not allowed to be marked invisible.
      As they are mandatory functionalities and hiding them will not be a requirement
      One can still re-order them in accounts section
    */
    if (['deposit', 'withdraw'].includes(componentName)) {
      return true
    }
    return isUpdateDisabled
  }

  return (
    <Card body className='reorder-ui-container'>
      <h5>Reorder and toggle visibility for components</h5>

      <div>
        <div className='d-flex justify-content-between mt-3'>
          {[
            'Priority',
            'Name',
            'Visibility'
          ].map((h) => (
            <div key={h}>{h}</div>
          ))}
        </div>

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={droppableId}>
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {data?.map(
                  (item, idx) => (
                    <Draggable draggableId={`id-${idx}`} key={idx} index={idx}>
                      {provided => (
                        <div
                          className='draggable-item'
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div>{idx + 1}</div>
                          <div>{item.displayName}</div>

                          <BForm.Check
                            type='switch'
                            name='hideWidget'
                            disabled={checkIsToggleHidden(item?.name)}
                            checked={item?.isVisible || false}
                            onChange={() => handleVisibilityToggle(idx)}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <Button
          className='m-1 mt-3'
          size='sm'
          variant='success'
          onClick={updateComponents}
          disabled={isUpdateDisabled}
        >Submit

          {loading && (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
            />
          )}
        </Button>
      </div>
    </Card>
  )
}

export default ReorderUIComponents
